module.exports = __webpack_public_path__ + "static/media/banner-bg.63bb4cc1.jpg";